import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change, reset } from 'redux-form'
import Calendar from 'react-calendar';
import Moment from 'react-moment'
import {
  Icon,
  Input,
  Form,
  Dropdown,
  Button,
  Popup
} from 'semantic-ui-react'
import {
  Collapse
} from '@material-ui/core';

import FieldInput, { InputType as type } from 'components/SemanticForm'
import {
  fetchProjects,
  getCompanies,
  fetchPOActiveVendors,
  fetchContractActiveVendors
} from 'ducks/options'
import {
  SearchCont,
  InputCont,
  AdvanceCont,
  DateCont
} from './styled'
import r from 'reactotron-react-js'

const SearchList = (props) => {
  const {
    projects,
    valueForm,
    change,
    companies,
    poVendors,
    contractVendors,
    //props
    pageSize,
    formSearchName,
    fetchAPI,
    placeholder = '',
    filterDate = false,
    filterStatus = false,
    filterCompany = false,
    hideProject = false,
    multiCompany = false,
    useLocalCompanyCode = false,
    isContractSearch = false,
    isPOSearch = false
  } = props

  const [visibleAS, setVisibleAS] = React.useState(true)
  const [date, setDate] = React.useState([null, null])

  React.useEffect(() => {
    props.fetchProjects()
    props.getCompanies()
    if (isContractSearch) {
      props.fetchContractActiveVendors()
    }
    if (isPOSearch) {
      props.fetchPOActiveVendors()
    }
    if (useLocalCompanyCode) {
      change(formSearchName, 'filter.companyCode', localStorage.getItem('filterCompanyCode') || '')
    }
  }, [])

  React.useEffect(() => {
    change(formSearchName, 'filter.dateStart', date[0] ? new Date(date[0]).toJSON() : '')
    change(formSearchName, 'filter.dateEnd', date[1] ? new Date(date[1]).toJSON() : '')
  }, [date])

  React.useEffect(() => {
    if (valueForm && valueForm.filter) {
      fetchAPI({ ...valueForm, page: 1, size: pageSize })
    }
  }, [valueForm && valueForm.filter])

  React.useEffect(() => {
    if (valueForm) {
      if (multiCompany) {
        if (valueForm.filter.companyCode) {
          localStorage.setItem('searchCompanyCode', JSON.stringify(valueForm.filter.companyCode))
        }
      }
      if (valueForm.filter.companyCode) {
        change(formSearchName, 'filter.projectId', [])
        props.fetchProjects(valueForm.filter.companyCode)
      } else if (!valueForm.filter.companyCode) {
        change(formSearchName, 'filter.projectId', [])
        props.fetchProjects()
      }
    }
  }, [valueForm && valueForm.filter && valueForm.filter.companyCode])


  React.useEffect(() => {
    if (valueForm && valueForm.dateStart && valueForm.dateEnd) {
      fetchAPI({ ...props.valueForm })
    }
  }, [valueForm && valueForm.dateStart, valueForm && valueForm.dateEnd])

  function setProjects() {
    if (projects.data) {
      return projects.data.sort((a, b) => a.text ? a.text.localeCompare(b.text) : -1)
    }
    return []
  }

  function setCompanies() {
    if (companies.data) {
      return companies.data.sort((a, b) => a.text ? a.text.localeCompare(b.text) : -1)
    }
    return []
  }

  function setVendors() {
    if (isPOSearch) {
      if (poVendors.data) {
        return poVendors.data.sort((a, b) => a.text ? a.text.localeCompare(b.text) : -1)
      }
    }
    if (isContractSearch) {
      if (contractVendors.data) {
        return contractVendors.data.sort((a, b) => a.text ? a.text.localeCompare(b.text) : -1)
      }
    }
    return []
  }

  function onResetClick() {
    change(formSearchName, 'filter', {})
    change(formSearchName, 'search.key', '')
    localStorage.setItem('filterCompanyCode', '')
  }


  function onAdvanceSearchClick(data) {
    if (valueForm) {
      fetchAPI({ ...props.valueForm, ...data, page: 1, size: pageSize })
    }
  }

  const statusOptions = () => {
    if (isPOSearch) {
      return [
        { key: 2, value: '0', text: 'Draft' },
        { key: 3, value: '1', text: 'New' },
        { key: 4, value: '2', text: 'In Progress' },
        { key: 5, value: '3', text: 'Revise' },
        { key: 6, value: '4', text: 'Completed' },
        { key: 7, value: '5', text: 'Reject' },
        { key: 8, value: '6', text: 'Cancelled' },
        { key: 13, value: '13', text: 'Accepted (Upload Stamp Duty)' },
        { key: 14, value: '14', text: 'Accepted (Review Stamp Duty)' },
      ]
    } else {
      return [
        { key: 2, value: '0', text: 'Draft' },
        { key: 3, value: '1', text: 'New' },
        { key: 4, value: '2', text: 'In Progress' },
        { key: 5, value: '3', text: 'Revise' },
        { key: 6, value: '4', text: 'Completed' },
        { key: 7, value: '5', text: 'Reject' },
        { key: 8, value: '6', text: 'Cancelled' },
      ]
    }
  }

  return (
    <SearchCont>
      <InputCont>
        <Field name="search.key" placeholder={placeholder} onSearchClick={() => onAdvanceSearchClick()} component={renderInputSearch} onEnter={() => onAdvanceSearchClick()} />
        <Icon name='settings' circular inverted link onClick={() => setVisibleAS(!visibleAS)} />
      </InputCont>
      <Collapse in={visibleAS} timeout="auto" unmountOnExit>
        <AdvanceCont>
          <div style={{ display: 'flex', flex: '1', alignItems: 'center' }}>
            <DateCont>
              {
                valueForm && valueForm.filter && valueForm.filter.dateStart ?
                  <React.Fragment>
                    <Moment format="DD MMM YYYY">{valueForm.filter.dateStart || Date.now()}</Moment>
                    {`  -  `}
                    <Moment format="DD MMM YYYY">{valueForm.filter.dateEnd || Date.now()}</Moment>
                  </React.Fragment>
                  :
                  'All Date time'
              }
            </DateCont>
            <div style={{ marginTop: '0.3rem' }}>
              <Popup trigger={<Button icon><Icon style={{ marginTop: '1.7rem' }} name='calendar alternate outline' /></Button>} flowing hoverable>
                <Calendar
                  onChange={(date) => {
                    setDate(date)
                  }}
                  value={date}
                  selectRange={true}
                />
              </Popup>
            </div>
            <div style={{ flex: '1' }}>
              <Field
                name='filter.status'
                label='Status'
                allowAdditions={false}
                options={statusOptions()}
                type={type.select}
                placeHolder='All Status'
                editable
                component={FieldInput}
              />
            </div>
          </div>
          <div style={{ flex: '1' }}>
            <Field
              name="filter.vendor"
              label="Vendor"
              allowAdditions={false}
              loading={poVendors.loading || contractVendors.loading}
              options={
                [
                  ...setVendors()
                ]
              }
              type={type.select}
              placeHolder='All Vendor'
              editable
              component={FieldInput}
            />
          </div>
        </AdvanceCont>
        <div style={{ display: 'flex' }}>
          {filterCompany && !multiCompany &&
            <Field
              name="filter.companyCode"
              label="Company"
              allowAdditions={false}
              loading={companies.loading}
              options={
                [
                  ...setCompanies()
                ]
              }
              specialOnChange={(value) => {
                if (useLocalCompanyCode) {
                  if (value) {
                    localStorage.setItem('filterCompanyCode', Number(value))
                  } else {
                    localStorage.setItem('filterCompanyCode', '')
                  }
                }
              }}
              placeHolder='All Company'
              editable
              type={multiCompany ? type.multiSelect : type.select}
              component={FieldInput}
            />}
          {
            hideProject ? null :
              <Field
                name="filter.projectId"
                label="Project"
                allowAdditions={false}
                loading={projects.loading}
                options={
                  [
                    ...setProjects()
                  ]
                }
                placeHolder='All Project'
                type={type.multiSelect}
                component={FieldInput}
              />
          }
        </div>
        <Button type='button' onClick={() => { reset(props.formSearchName); onResetClick() }}>Clear</Button>
      </Collapse>
    </SearchCont>
  )

}

const renderInputSearch = props => {
  const { input, onSearchClick, placeholder } = props
  return (
    <Input
      {...input}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          props.onEnter()
        }
      }}
      className='searchInput'
      icon={<Icon type='button' name='search' inverted circular link onClick={onSearchClick} />}
      placeholder={placeholder} />
  )
}

const mapStateToProps = (state, props) => {
  return ({
    valueForm: getFormValues(props.formSearchName)(state),
    companies: state.options.companies,
    projects: state.options.projects,
    poVendors: state.options.poVendors,
    contractVendors: state.options.contractVendors
  })
}

const mapDispatchToProps = {
  fetchProjects,
  getCompanies,
  change,
  reset,
  fetchPOActiveVendors,
  fetchContractActiveVendors
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchList)
